// ** Theme Type Import
import { Theme } from '@mui/material';

const Typography = (theme: Theme) => {
  return {
    h1: {
      fontSize: '1.5rem',
      fontWeight: 400,
    },
    h2: {
      fontSize: '1.375rem',
      fontWeight: 400,
    },
    h3: {
      fontSize: '1.125rem',
      fontWeight: 400,
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '0.75rem',
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: 12,
    },
    subtitle2: {
      background: '#FFF none repeat scroll 0 0',
      boxDecorationBreak: 'clone',
      display: 'inline',
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 16,
      paddingRight: 16,
      lineHeight: 2.8,
      boxShadow: '-5px 5px 0 #000',
      border: '2px solid #000',
      borderRadius: 16,
    },
    body1: {
    },
    body2: {
    },
    button: {
    },
    caption: {
    },
    overline: {
    },
  };
};

export default Typography;
